import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Components } from "react-markdown";
import { StyledWrapper } from "./styles";

interface MarkdownRendererProps {
  content: string;
}

const markdownComponents: Components = {
  div: ({ node, ...props }) => {
    const type = (props as any)["data-type"];
    const name = (props as any)["data-name"];

    if (type === "Component" && name === "ClickMeButton") {
      return (
        <button
          onClick={() => alert("Clicked!")}
          style={{
            backgroundColor: "#007bff",
            color: "#000",
            padding: "10px 20px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Click Me!
        </button>
      );
    }

    return <div {...props} />;
  },
};

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <StyledWrapper>
      <ReactMarkdown
        children={content}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={markdownComponents}
      />
    </StyledWrapper>
  );
};

export default MarkdownRenderer;
